import {Component, Inject, OnInit} from '@angular/core';
import {APP_VERSION} from '../../core/consts/app-version';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FirebaseService} from '../../services/firebase.service';
import {TranslationService} from '../../core/_base/layout';
import {take} from 'rxjs/operators';
import {ChangelogService} from '../../services/changelog.service';

@Component({
  selector: 'kt-changelog-dialog',
  templateUrl: './changelog-dialog.component.html',
  styleUrls: ['./changelog-dialog.component.scss']
})
export class ChangelogDialogComponent implements OnInit {

  lastChangelog = null;
  appVersion = APP_VERSION;
  loading = false;
  showAgain = true;

  constructor(
    public dialogRef: MatDialogRef<ChangelogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {currentUser: any, openedManually: boolean},
    private firebase: FirebaseService,
    private changelog: ChangelogService,
    private translations: TranslationService,
  ) { }

  ngOnInit(): void {
    this.getLastChangelog();
  }
  getLastChangelog() {
    this.loading = true;
    this.changelog.getCurrentVersionChangelog(this.appVersion).pipe(take(1)).subscribe((changelog:any) => {
      changelog = changelog[0];
      this.lastChangelog = changelog;
      this.loading = false;
    });
  }
  getCurrentLanguage() {
    return this.translations.getSelectedLanguage();
  }
  formatChangelogDate(date) {
    date = +date;
    const formatted = new Date(date);
    const transformLanguage = this.getCurrentLanguage() === 'de' ?  'de-DE' : 'en-US';
    return formatted.toLocaleDateString(transformLanguage, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
  toggleShowAgain() {
    this.data.currentUser.changelogDialogLive.showAgain = this.showAgain;
    this.data.currentUser.changelogDialogLive.lastSeenVersion = this.appVersion;
    this.firebase.updateUser(this.data.currentUser.uid, this.data.currentUser);
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
